import { render, staticRenderFns } from "./addProductnew.vue?vue&type=template&id=3ab7da40&scoped=true"
import script from "./addProductnew.vue?vue&type=script&lang=js"
export * from "./addProductnew.vue?vue&type=script&lang=js"
import style0 from "./addProductnew.vue?vue&type=style&index=0&id=3ab7da40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7da40",
  null
  
)

export default component.exports